// removed by extract-text-webpack-plugin
module.exports = {"container":"_11b4cacacb_src-common-PageLayout-_NotificationsMenu_container","header":"_12aaea99e2_src-common-PageLayout-_NotificationsMenu_header","body":"_8d4b6b52c1_src-common-PageLayout-_NotificationsMenu_body","notification":"d1a5bca9e0_src-common-PageLayout-_NotificationsMenu_notification","date":"_060da8ae55_src-common-PageLayout-_NotificationsMenu_date","title":"_4b49934121_src-common-PageLayout-_NotificationsMenu_title","content":"c8b8c4b10b_src-common-PageLayout-_NotificationsMenu_content","empty":"d6154179a0_src-common-PageLayout-_NotificationsMenu_empty"};


//////////////////
// WEBPACK FOOTER
// ./src/common/PageLayout/NotificationsMenu.css
// module id = 1020
// module chunks = 0